<template>
  <thead class="table">
    <tr>
      <th rowspan="2" class="text-center" style="padding-top: 35px">
        {{ $t('common_words.mayus_allotment') }}
      </th>
      <th rowspan="2" class="text-center" style="padding-top: 35px">
        {{ $t('common_words.mayus_week') }}
      </th>
      <th :colspan="getSizeDataEvaluation" class="text-center">
        {{ evaluation.split('_')[1] }}
      </th>
      <th rowspan="2" class="text-center" style="padding-top: 35px">
        {{ $t('common_words.mayus_average') }}
      </th>
    </tr>
    <tr>
      <template v-for="(values, subcategory) in dataEvaluations">
        <th
          scope="col"
          v-if="values.containObjetive || values.general"
          :key="subcategory"
          class="text-center"
        >
          {{ subcategory.split('_')[1] }}
        </th>
      </template>
    </tr>
  </thead>
</template>
<script>
export default {
  name: 'thead-compliance',
  props: {
    dataEvaluations: {
      type: Object,
    },
    evaluation: {
      type: String,
    },
  },
  computed: {
    getSizeDataEvaluation() {
      const result = Object.values(this.dataEvaluations).filter(
        (values) => values.containObjetive || values.general
      );

      return result.length;
    },
  },
};
</script>
